import script from "./PopoverModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopoverModal.vue?vue&type=script&setup=true&lang=ts"

import "./PopoverModal.vue?vue&type=style&index=0&id=5e5c36df&lang=scss"

const __exports__ = script;

export default __exports__